export default "__VITE_ASSET__0001df50__"